import * as i0 from '@angular/core';
import * as i1 from './timepicker.module';
import * as i2 from '@angular/common';
import * as i3 from './timepicker';
export const NgbTimepickerModuleNgFactory:i0.NgModuleFactory<i1.NgbTimepickerModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.NgbTimepicker = (<any>(null as any));
var _decl0_12:i2.AsyncPipe = (<any>(null as any));
var _decl0_13:i2.UpperCasePipe = (<any>(null as any));
var _decl0_14:i2.LowerCasePipe = (<any>(null as any));
var _decl0_15:i2.JsonPipe = (<any>(null as any));
var _decl0_16:i2.SlicePipe = (<any>(null as any));
var _decl0_17:i2.DecimalPipe = (<any>(null as any));
var _decl0_18:i2.PercentPipe = (<any>(null as any));
var _decl0_19:i2.TitleCasePipe = (<any>(null as any));
var _decl0_20:i2.CurrencyPipe = (<any>(null as any));
var _decl0_21:i2.DatePipe = (<any>(null as any));
var _decl0_22:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_23:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_24:i2.CommonModule = (<any>(null as any));
function _View_NgbTimepicker_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_NgbTimepicker_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_11.disabled;
  currVal_0;
  const currVal_1:any = _decl0_11.disabled;
  currVal_1;
  const currVal_2:any = _decl0_11.spinners;
  currVal_2;
  const currVal_3:any = 'form-control';
  currVal_3;
  const currVal_4:any = _decl0_11.setFormControlSize();
  currVal_4;
  const currVal_5:any = _decl0_11.formatHour(((_decl0_11.model == null)? (null as any): _decl0_11.model.hour));
  currVal_5;
  const currVal_6:any = _decl0_11.readonlyInputs;
  currVal_6;
  const currVal_7:any = _decl0_11.disabled;
  currVal_7;
  const currVal_8:any = _decl0_11.spinners;
  currVal_8;
  const currVal_9:any = _decl0_11.spinners;
  currVal_9;
  const currVal_10:any = 'form-control';
  currVal_10;
  const currVal_11:any = _decl0_11.setFormControlSize();
  currVal_11;
  const currVal_12:any = _decl0_11.formatMinSec(((_decl0_11.model == null)? (null as any): _decl0_11.model.minute));
  currVal_12;
  const currVal_13:any = _decl0_11.readonlyInputs;
  currVal_13;
  const currVal_14:any = _decl0_11.disabled;
  currVal_14;
  const currVal_15:any = _decl0_11.spinners;
  currVal_15;
  const currVal_16:any = _decl0_11.seconds;
  currVal_16;
  const currVal_17:any = _decl0_11.seconds;
  currVal_17;
  const currVal_18:any = _decl0_11.meridian;
  currVal_18;
  const currVal_19:any = _decl0_11.meridian;
  currVal_19;
  const pd_20:any = ((<any>_decl0_11.updateHour(_any.target.value)) !== false);
  const pd_21:any = ((<any>_decl0_11.updateMinute(_any.target.value)) !== false);
}
